import { PropsWithChildren } from 'react';
import { Tooltip } from '@mui/material';

export default function MyTooltip({
	children,
	title = 'Tooltip text here',
}: {
	title?: string;
	children?: React.ReactElement<any, any>;
}) {
	if (!children) return <></>;

	return (
		<Tooltip title={title} arrow>
			{children ? children : <span>{'Content'}</span>}
		</Tooltip>
	);
}
